export default {"src":"/_next/static/media/carFilled_40.380575db.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};